import { Uuid } from '../types/uuid';
import { v4 as uuidv4 } from "uuid";

export function uuid(): Uuid  {
  return uuidv4() as Uuid;
}
